<div
  class="xi-modal__container create-action-task__container"
  *transloco="let t; read: 'create-action-task-dialog-component'"
>
  @if (currentStep === 1) {
    <h2 class="xi-modal__title">{{ title }}</h2>
    <form
      autocomplete="off"
      [formGroup]="form"
      class="xi-modal__content create-action-task__content"
    >
      <div>
        <label class="kxi-input-label kxi-normal-contrast">{{ t('selected-plan') }}</label>
        <div class="create-action-task__action-plan-blobs">
          <app-lex-blue-pill [text]="actionPlan.metadata.breakdown"></app-lex-blue-pill>
          <app-lex-blue-pill [text]="actionPlan.metric_name"></app-lex-blue-pill>
        </div>
      </div>
      <div>
        <label class="kxi-input-label kxi-normal-contrast">{{ t('selected-item') }}</label>
        <app-lex-blue-pill [text]="actionItem.name"></app-lex-blue-pill>
      </div>
      <xi-input-field
        label="{{ t('name') }}"
        formControlName="name"
        placeholder="{{ t('name-placeholder') }}"
        [status]="nameStatus"
      ></xi-input-field>
      <div class="create-action-task__date-assignee-row">
        <xi-date-picker
          [direction]="3"
          label="{{ t('due-date') }}"
          [status]="dueDateStatus"
          [dateValue]="form.controls.dueDate.value"
          [minDate]="minDueDate"
          [maxDate]="maxDueDate"
          formControlName="dueDate"
          placeholder="{{t('date-placeholder)}}"
        ></xi-date-picker>
        <xi-input-field
          label="{{ t('assign-label') }}"
          formControlName="assignee"
          placeholder="{{ t('assign-placeholder') }}"
        ></xi-input-field>
      </div>
      <xi-text-area
        label="{{ t('note') }}"
        formControlName="note"
        placeholder="{{ t('note-placeholder') }}"
        type="text"
      ></xi-text-area>
    </form>
    <div class="xi-modal__actions create-action-task__first-step-actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>
      <div class="xi-loader-button-container">
        <xi-default-button
          [text]="saveButtonText"
          [disabled]="form.invalid || isSaving"
          (onClick)="onAddTask()"
        >
        </xi-default-button>
        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  }
  @if (currentStep === 2) {
    <div class="xi-modal__content create-action-task__content-svg">
      <xi-svg svg="celebration"></xi-svg>
    </div>
    <div class="create-action-task__done-title">
      <div>
        {{
          t('successfully-added', {
            createdTaskName: createdTaskName,
            actionItemName: actionItem.name,
          })
        }}
      </div>
      @if (!isEdit) {
        <div>{{ t('add-more') }}</div>
      }
    </div>
    <div class="xi-modal__actions">
      <xi-default-button
        fill="text"
        [text]="fromDashboard ? t('back-to-dashboard') : t('close')"
        (onClick)="onCancel()"
      ></xi-default-button>
      @if (!isEdit) {
        <xi-default-button
          text="{{ t('add-task') }}"
          (onClick)="onAddAnotherTask()"
        ></xi-default-button>
      }
    </div>
  }
</div>
